import React from "react";
import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import dayjs from "dayjs";

const getYears = (memberSince) => {
  const firstYear = memberSince.split(",")[1].trim();
  let currentYear = dayjs().format("YYYY");
  const current = parseInt(currentYear, 10);
  const start = parseInt(firstYear, 10);
  const years = ["Select a Year"];

  for (let x = current; x >= start; x--) {
    years.push(x);
  }
  return years;
};

const handleSelect = (history, chimDir, event) => {
  history.push(`/profile/${chimDir}/tracks/year/${event.target.value}`);
};

const ProfileArchiveSelect = ({ chimDir, memberSince, title = null }) => {
  let history = useHistory();
  const year = memberSince.split(",")[1] || null;
  if (!year) {
    return null;
  }
  return (
    <div className="profile-right-nav profile-archive-select">
      {title && <h3>{title}</h3>}
      <div>
        <Form className="profile-archive-form" noValidate onSubmit={false}>
          <Form.Group controlId="archiveYear">
            <Form.Control as="select" onChange={(e) => handleSelect(history, chimDir, e)}>
              {getYears(memberSince).map((year) => (
                <option value={year}>{year}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};

export default ProfileArchiveSelect;
